import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import dayjs from "dayjs";

import { Section } from "shared/layout";
import Button from "shared/Button";

import { Ok, Danger, Lock } from "react-ikonate";
import Loader from "shared/Loader";
import TabActionBar from "shared/TabActionBar";

export default function TopicsHistory({
  ibo,
  isCreatingIbo,
  refresh,
  onClose,
  isShowHistory,
  onCancel,
  showMarkComplete,
  syncTopicsAccount,
}) {
  const [contact, setContact] = useState(ibo);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [canResync, setCanResync] = useState(false);
  const [errors, setErrors] = useState(false);

  useEffect(() => {
    setIsRefreshing(false);
    setContact(ibo);
  }, [ibo]);

  useEffect(() => {
    if (contact && contact.actions) {
      if (
        contact.actions.some(
          (action) => action.errors && action.errors.length > 0
        )
      ) {
        setErrors(true);
      }
    }
  }, [contact, errors]);

  useEffect(() => {
    if (contact && !canResync) {
      let timer = setTimeout(() => {
        refresh(contact);
      }, [1000 * 8]);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [contact, canResync]);

  useEffect(() => {
    if (!contact.isSyncing && contact.actions && contact.actions.length > 0) {
      setCanResync(true);
    } else {
      setCanResync(false);
    }
  }, [contact]);

  // compare sync start time with current date/time
  let currDateObj = new Date();

  return (
    <div>
      <Section className={styles.section}>
        <TabActionBar>
          <header className={styles.tabActionBarHeader}>
            <h3 className={styles.title}>
              {contact.wwgInfo.firstName} {contact.wwgInfo.lastName} (
              {contact.wwgInfo.type})
              {!contact.isSyncing &&
                contact.actions &&
                contact.actions.length > 0 && (
                  <span className={styles.complete}>
                    - COMPLETED{" "}
                    {dayjs(contact.actions[contact.actions.length - 1].endedOn)
                      .tz("America/Los_Angeles")
                      .format("MM/DD/YY HH:mm:ss")}
                  </span>
                )}
              {contact.isSyncing && (
                <div>
                  <Loader size={25} />
                </div>
              )}
            </h3>

            <div>
              {showMarkComplete && (
                <>
                  {/* Always show Clear Errors immediately when errors exist */}
                  {!isRefreshing &&
                    contact.actions &&
                    contact.actions.length > 0 &&
                    errors && (
                      <Button
                        size="small"
                        onClick={async () => {
                          onCancel();
                          onClose();
                          setErrors(false);
                          setIsRefreshing(true);
                          await refresh(contact);
                          setIsRefreshing(false);
                        }}
                        style={{ backgroundColor: "red" }}
                      >
                        Clear Errors
                      </Button>
                    )}
                  {!errors &&
                    !isRefreshing &&
                    contact.isSyncing &&
                    contact.actions &&
                    contact.actions.length > 0 &&
                    (currDateObj - new Date(contact.actions[0].startedOn)) /
                      60000 >
                      5 && (
                      <Button
                        size="small"
                        onClick={async () => {
                          onCancel();
                          onClose();
                          setErrors(false);
                          setIsRefreshing(true);
                          await refresh(contact);
                          setIsRefreshing(false);
                        }}
                      >
                        Mark Complete
                      </Button>
                    )}
                </>
              )}
              {isCreatingIbo && errors && (
                <Button
                  size="small"
                  onClick={() => {
                    onCancel(contact);
                    onClose();
                    setErrors(false);
                    refresh(contact);
                  }}
                  style={{ backgroundColor: "red" }}
                >
                  Clear Errors
                </Button>
              )}
              {!isRefreshing ? (
                <>
                  &nbsp;
                  {canResync && !isShowHistory ? (
                    <Button
                      size="small"
                      purpose={"delete"}
                      onClick={() => {
                        if (
                          window.confirm(
                            `Initialize Sync (last sync ${
                              contact.actions && contact.actions.length > 0
                                ? dayjs(
                                    contact.actions[contact.actions.length - 1]
                                      .endedOn
                                  )
                                    .tz("America/Los_Angeles")
                                    .format("MM/DD/YY HH:mm:ss")
                                : "information unavailable"
                            })?`
                          )
                        ) {
                          syncTopicsAccount(ibo);
                        }
                        setIsRefreshing(true);
                        refresh(contact);
                        setCanResync(false);
                      }}
                    >
                      Sync
                    </Button>
                  ) : (
                    <Button
                      size="small"
                      onClick={async () => {
                        setIsRefreshing(true);
                        await refresh(contact);
                        setIsRefreshing(false);
                      }}
                    >
                      Refresh
                    </Button>
                  )}
                </>
              ) : (
                <Loader size={25} />
              )}
              &nbsp;
              {!isCreatingIbo && (
                <Button
                  size="small"
                  onClick={() => {
                    refresh(contact);
                    onClose();
                  }}
                >
                  Close
                </Button>
              )}
            </div>
          </header>
        </TabActionBar>
      </Section>

      <Section>
        <div>
          <header>
            {contact.actions && contact.actions.length > 0 ? (
              <h3>History</h3>
            ) : (
              <div>
                {isCreatingIbo
                  ? "Creating Account. Refresh for more Details."
                  : "Getting account information, please wait or click refresh..."}
                <span className={styles.loader2}>
                  <Loader size={50} />
                </span>
              </div>
            )}
          </header>
          {contact.actions &&
            contact.actions.map((doc, index) => {
              return (
                <React.Fragment key={index}>
                  <header className={styles.gridHeader}>
                    <div>Step {doc.step}:</div>
                    <div>Started</div>
                    <div>Ended</div>
                  </header>
                  <ul>
                    <GroupEntry
                      key={doc._id}
                      icon={
                        doc.startedOn && doc.errors.length === 3 ? (
                          <Danger className={styles.failure} />
                        ) : doc.startedOn &&
                          doc.endedOn !== null &&
                          doc.errors.length !== 3 ? (
                          <Ok className={styles.success} />
                        ) : !doc.startedOn ? (
                          <Lock />
                        ) : (
                          <Danger />
                        )
                      }
                      name={
                        <div className={styles.gridRow}>
                          <div>{doc.name}</div>
                          <div>
                            {doc.startedOn
                              ? dayjs(doc.startedOn)
                                  .tz("America/Los_Angeles")
                                  .format("MM/DD/YY HH:mm:ss")
                              : "Starting"}
                          </div>
                          <div>
                            {doc.endedOn
                              ? dayjs(doc.endedOn)
                                  .tz("America/Los_Angeles")
                                  .format("MM/DD/YY HH:mm:ss")
                              : "In Progress"}
                          </div>
                        </div>
                      }
                    >
                      {doc.logs.length ? <div className={styles.hr} /> : ""}
                      <ul className={styles.logs}>
                        {doc.logs.length ? (
                          <>
                            <li>
                              <div>Logs:</div>
                            </li>
                            {doc.logs.map((log, i) => (
                              <li key={i} className={styles.logGridRow}>
                                <div className={styles.logDescription}>
                                  {log.description}
                                </div>
                                <div>
                                  {dayjs(log.timestamp)
                                    .tz("America/Los_Angeles")
                                    .format("MM/DD/YY HH:mm:ss")}
                                </div>
                              </li>
                            ))}
                          </>
                        ) : (
                          ""
                        )}

                        {doc.errors.length ? (
                          <>
                            <li>
                              <div>Errors:</div>
                            </li>
                            {doc.errors.map((error, i) => (
                              <li key={i} className={styles.logGridRow}>
                                <div>{error.description}</div>
                                <div></div>
                                <div className={styles.time}>
                                  {dayjs(error.timestamp)
                                    .tz("America/Los_Angeles")
                                    .format("MM/DD/YY HH:mm:ss")}
                                </div>
                              </li>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                      </ul>
                    </GroupEntry>
                  </ul>
                </React.Fragment>
              );
            })}
        </div>
      </Section>
    </div>
  );
}

export function GroupEntry({ icon, name, data, children }) {
  return (
    <li className={styles.groupEntry}>
      <div className={styles.groupEntryName}>
        <div>{icon}</div>
        {name}
      </div>
      {children}
    </li>
  );
}

export function Load({ iboNumber, refresh }) {
  return (
    <div className={styles.loader}>
      <Section>
        <header>
          <h3>Creating Account. Refresh for more Details.</h3>
          <div className={styles.buttons}>
            <Loader />
            <Button
              size="small"
              onClick={() => {
                refresh(iboNumber);
              }}
            >
              Refresh
            </Button>
          </div>
        </header>
      </Section>
    </div>
  );
}
